import AuditCertificateList from '@/pages/components/manage/other/audit-certificate/AuditCertificateList';

export default {
    list: AuditCertificateList,
};
